














































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput, mdbSelect } from '@folky-tools/mdbvue';
import { Association } from '@/models/associations/association';
import { Project } from '@/models/projects/project';
import { Pricing } from '@/models/pricings/pricing';
import { projectsService, pricingsService } from '@/services';
import { required, minValue } from 'vuelidate/lib/validators';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbInput,
        mdbSelect
    },
    validations: {
        association: {
            name: { required },
            projectId: { required, minValue: minValue(1) },
            pricingId: { required, minValue: minValue(1) }
        }
    }
})
export default class AssociationBasicData extends Vue {
    @Prop(Association) private association!: Association;
    @Prop() private singleColumnForm?: boolean;
    @Prop() private disableProjectsSelection?: boolean;
    @Prop() private disablePricingsSelection?: boolean;
    private projects: Project[] = [];
    private pricings: Pricing[] = [];

    private async mounted(): Promise<void> {
        const projects: Project[] = await projectsService.getProjects();
        if (this.association.projectId > 0) {
            projects.find(p => p.id === this.association.projectId)!.selected = true;
        }

        this.projects = projects;
    }

    private async onChangeProject(value: number, text: string): Promise<void> {
        if (value) {
            const selectedProject = this.projects.find(p => p.id === value);
            this.association.projectId = selectedProject!.id;
            this.association.projectName = selectedProject!.name;

            const pricings = await pricingsService.getPricings([this.association.projectId]);

            if (this.association.pricingId > 0 && pricings.some(p => p.id === this.association.pricingId)) {
                pricings.find(p => p.id === this.association.pricingId)!.selected = true;
            }
            this.pricings = pricings;
        } else {
            this.pricings = [];
            this.association.pricingId = 0;
            this.association.pricingName = undefined;
        }
    }

    private onChangePricing(value: number, text: string) {
        if (value) {
            const selectedPricing = this.pricings.find(p => p.id === value);
            this.association.pricingId = selectedPricing!.id;
            this.association.pricingName = selectedPricing!.name;
        } else {
            this.association.pricingId = 0;
            this.association.pricingName = undefined;
        }
    }

    private hasErrors(): boolean {
        this.$v.association.$touch();
        if (this.$v.association.$error) {
            return true;
        }
        return false;
    }
}
